"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value === undefined;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isUndefined.js
// module id = 2152
// module chunks = 0